export default __webpack_public_path__ + "static/media/typeL_high.c5f767b9.png";